import React from 'react'
import { useParams } from 'react-router-dom'
import MilestoneForm from './MilestoneForm'

const MilestoneView = () => {
  const { id } = useParams()
  
  return <MilestoneForm mode="view" milestoneId={id} />
}

export default MilestoneView

